













































































































































































































































































































import { defineComponent, reactive, toRefs, ref, onMounted, watch, computed, onBeforeUnmount } from '@vue/composition-api';
import http from "../../plugins/http"
import * as Common from "../../commons/common"
import moment from 'moment'
import { BModal, BCarousel } from 'bootstrap-vue';
import AlertArea from "../../components/AlertArea.vue"
import PracticeSumupResultRankTab from "../../components/PracticeSumupResultRankTab.vue"
import { SumupGroup, SumupUnitExaminee, SumupUnitAll, Assessment, SearchCondtion, AssessmentExaminee, BaseAssessment } from "../../modules/teacher/PracticeSumupResultRankListCurriculum"

export interface Data {
  sumup_unit_id: string
  sumup_unit_name: string
  condition: SearchCondtion
  sumupGroup: SumupGroup
  sumupUnitExaminees: SumupUnitExaminee[]
  filteredSumupUnitExaminees: SumupUnitExaminee[]
  sumupUnitAll: SumupUnitAll
  additionTarget: SumupUnitExaminee
  assessments: Assessment[]
  fields: any[]
  isAllChecked: boolean
  previewActive: boolean,
  carouselPageIdx: number
  windowHeight: number
  modalTarget: SumupUnitExaminee
  isShowCarousel: boolean
  errors: string[]
  modalErrors: string[]
  examineeColspan: number
  scoreColspan: number
  assessmentColspan: number
  isDispGender: boolean
  isDispAssessment: boolean
  baseAssessments: BaseAssessment[]
  sheet_group_key: number
  isPdfDownloadSingleFile: boolean
}

export default defineComponent({
  components: {
    "practice-sumup-result-rank-tab": PracticeSumupResultRankTab,
    "alert-area": AlertArea,
  },
  setup(_, context){

    const additionModalRef = ref<InstanceType<typeof BModal>>();
    const assessmentModalRef = ref<InstanceType<typeof BModal>>();
    const imageModalRef = ref<InstanceType<typeof BModal>>();
    const carouselRef = ref<InstanceType<typeof BCarousel>>();
    const pdfDownlaodModalRef = ref<InstanceType<typeof BModal>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sumup_unit_id: "",
      sumup_unit_name: "",
      condition: new SearchCondtion(),
      sumupGroup: null,
      sumupUnitExaminees: [],
      filteredSumupUnitExaminees: [],
      sumupUnitAll: null,
      additionTarget: null,
      assessments: [],
      fields: [],
      isAllChecked: false,
      previewActive: false,
      carouselPageIdx: 0,
      windowHeight: 0,
      modalTarget: null,
      isShowCarousel: false,
      errors: new Array<string>(),
      modalErrors: [],
      examineeColspan: 0,
      scoreColspan: 0,
      assessmentColspan: 0,
      isDispGender: false,
      isDispAssessment: false,
      baseAssessments: [],
      sheet_group_key: null,
      isPdfDownloadSingleFile: false
    });

    /************************************************************
     * 採点結果画像モーダル表示
     ************************************************************/

    const previewImage = async (sumupUnitExaminee: SumupUnitExaminee) => {
      if(!sumupUnitExaminee.isDownloaded){
        await downloadResultImage(sumupUnitExaminee);
      }

      state.modalTarget = sumupUnitExaminee;
      state.isShowCarousel = true;
      state.carouselPageIdx = 0;
      imageModalRef.value.show();
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 採点結果画像ダウンロード
     ************************************************************/

    const downloadResultImage = async (sumupUnitExaminee: SumupUnitExaminee) => {
      context.root.$store.dispatch("showOverlay");
        await http.get(`/api/teacher/practice_sumup_result_rank_list_curriculum/download_result_image/${state.sheet_group_key}/${sumupUnitExaminee.student_no_character}`).then(response => {
          sumupUnitExaminee.base64Images = response.data.base64_images;
          sumupUnitExaminee.isDownloaded = true;
          const r = state.sumupUnitExaminees.filter(x => x.practice_examinee_id == sumupUnitExaminee.practice_examinee_id)[0];
          r.base64Images = response.data.base64_images;
          r.isDownloaded = true;
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
        context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 画像モーダル 前ページへ
     ************************************************************/
    const carouselPrev = () => {
      carouselRef.value.prev();
      if(state.carouselPageIdx > 0){
        state.carouselPageIdx--;
      }else{
        state.carouselPageIdx = state.modalTarget.base64Images.length -1;
      }
    };

    /************************************************************
     * 画像モーダル 次ページへ
     ************************************************************/
    const carouselNext = () => {
      carouselRef.value.next();
      if(state.carouselPageIdx + 1 < state.modalTarget.base64Images.length){
        state.carouselPageIdx++;
      }else{
        state.carouselPageIdx = 0;
      }
    };

    /************************************************************
     * 画像モーダル 前の生徒へ
     ************************************************************/

    const changePrevResultImageModal = async () => {
      const idx = state.filteredSumupUnitExaminees.indexOf(state.modalTarget);
      
      if(idx > 0){
        if(!state.filteredSumupUnitExaminees[idx - 1].isDownloaded){
          await downloadResultImage(state.filteredSumupUnitExaminees[idx - 1]);
        }
        state.modalTarget = state.filteredSumupUnitExaminees[idx - 1];
        carouselRef.value.setSlide(state.carouselPageIdx);
      }
    };

    /************************************************************
     * 画像モーダル 次の生徒へ
     ************************************************************/

    const changeNextResultImageModal = async () => {
      const idx = state.filteredSumupUnitExaminees.indexOf(state.modalTarget);
      
      if(idx < state.filteredSumupUnitExaminees.length - 1){
        if(!state.filteredSumupUnitExaminees[idx + 1].isDownloaded){
          await downloadResultImage(state.filteredSumupUnitExaminees[idx + 1]);
        }
        state.modalTarget = state.filteredSumupUnitExaminees[idx + 1];
        carouselRef.value.setSlide(state.carouselPageIdx);
      }
    };

    /************************************************************
     * 画面リサイズ時のウィンドウの高さを保持
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      state.windowHeight = windowHeight;
    };

    /******************************
     * 備考モーダル表示
     ******************************/

    const showAdditionModal = (target: SumupUnitExaminee) => {
      state.additionTarget = target;
      additionModalRef.value.show();
    }

    /******************************
     * 検索
     ******************************/

    const search = () => {
      let filteredSumupUnitExaminees = state.sumupUnitExaminees.map(x => x);
      if(state.condition.student_no_character){
        filteredSumupUnitExaminees = state.sumupUnitExaminees.filter(x => x.student_no_character == state.condition.student_no_character);
      }
      if(state.condition.student_name){
        filteredSumupUnitExaminees = filteredSumupUnitExaminees.filter(x => x.student_name.includes(state.condition.student_name));
      }
      state.filteredSumupUnitExaminees = filteredSumupUnitExaminees;
    }

    /******************************
     * クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondtion();
    }

    /******************************
     * 実施日を画面表示文言にコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('Y年M月D日実施') : "-";
    };

    /******************************
     * 一覧得点列のフォーマッター
     ******************************/

    const scoreFormatter = (value: any) => {
      return `${value}点`;
    }

    /******************************
     * 一覧順位列のフォーマッター
     ******************************/

    const rankFormatter = (value: any) => {
      return `${value}位`;
    }

    /******************************
     * 答案DL列ヘッダーCheckBoxの監視
     ******************************/

    watch(() => state.isAllChecked, (newVal, oldVal) => {
      state.sumupUnitExaminees.filter(x => x.result_image_created).forEach(x => x.isSelected = newVal);
    });

    /******************************
     * ダウンロード
     ******************************/

    const downloadPdf = async () => {

      const studentNoCharacters = state.sumupUnitExaminees.filter(x => x.result_image_created && x.isSelected).map(x => x.student_no_character);
      if(studentNoCharacters.length == 0){
        alert("ダウンロード対象の生徒を選択してください。");
        return;
      }

      if(!window.confirm("答案をダウンロードします。よろしいですか？")){
        return;
      }

      pdfDownlaodModalRef.value.hide();

      const param = {
        student_no_characters: studentNoCharacters
      }

      const apiName = state.isPdfDownloadSingleFile ? "download_pdf_single" : "download_pdf_multi";

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/practice_sumup_result_rank_list_curriculum/${apiName}/${state.sumupGroup.id}/${state.sheet_group_key}`, param, {responseType: 'arraybuffer'}).then(response => {
        if(state.isPdfDownloadSingleFile){
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const a = document.createElement('a');
          a.href = window.URL.createObjectURL(blob);
          a.download = `${state.sumupGroup.name}_${state.sumup_unit_name}.pdf`;
          a.click();
        }else{
          const blob = new Blob([response.data], { type: 'application/zip' });
          const a = document.createElement('a');
          a.href = window.URL.createObjectURL(blob);
          a.download = `${state.sumupGroup.name}_${state.sumup_unit_name}.zip`;
          a.click();
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          state.errors = errorData.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 判定設定モーダル表示
     ******************************/

    const showAssessmentModal = () => {
      assessmentModalRef.value.show();
    }

    /******************************
     * 評価情報追加
     ******************************/

    const addAssessment = (assessment: Assessment) => {
      state.assessments.push(createEmptyAssessment());
    }

    /******************************
     * 評価情報削除
     ******************************/

    const deleteAssessment = (assessment: Assessment) => {
      const idx = state.assessments.indexOf(assessment);
      state.assessments.splice(idx, 1);
    }


    /******************************
     * 空の評価オブジェクト追加
     ******************************/

    const createEmptyAssessment = () => {
      const assessment = new Assessment(state.baseAssessments);
      return assessment;
    }

    /******************************
     * 判定更新ボタン押下
     ******************************/

    const updateAssessment = async () => {

      state.modalErrors = [];

      state.assessments.forEach((assessment, i) => {

        if(!assessment.name){
          state.modalErrors.push(`${i + 1}件目の名称が入力されていません。`);
        }

        if(assessment.assessment_scores.length < 2){
          state.modalErrors.push(`${i + 1}件目の判定情報が行数が不足しています。最低2行登録してください。`);
        }

        assessment.assessment_scores.forEach((assessment_score, j) => {
          if(!assessment_score.name){
            state.modalErrors.push(`${i + 1}件目の${j + 1}行目の判定名が入力されていません。`);
          }

          if(j + 1 == assessment.assessment_scores.length){
            return;
          }

          if(assessment.is_gender_separate){
            if(!assessment_score.man_score || !assessment_score.woman_score){
              state.modalErrors.push(`${i + 1}件目の${j + 1}行目の閾値が入力されていません。`);
            }else if(!Common.isFloatOrInteger(assessment_score.man_score) || !Common.isFloatOrInteger(assessment_score.woman_score)){
              state.modalErrors.push(`${i + 1}件目の${j + 1}行目の閾値に数字以外が入力されています。`);
            }else{
              if(j != 0 && j != assessment.assessment_scores.length - 1){
                if(Number(assessment_score.man_score) >= Number(assessment.assessment_scores[j - 1].man_score) || Number(assessment_score.woman_score) >= Number(assessment.assessment_scores[j - 1].woman_score)){
                  state.modalErrors.push(`${i + 1}件目の${j + 1}行目の閾値が高い順に入力されていません。`);
                }
              }
            }
          }else{
            if(!assessment_score.total_score){
              state.modalErrors.push(`${i + 1}件目の${j + 1}行目の閾値が入力されていません。`);
            }else if(!Common.isFloatOrInteger(assessment_score.total_score)){
              state.modalErrors.push(`${i + 1}件目の${j + 1}行目の閾値に数字以外が入力されています。`);
            }else{
              if(j != 0 && j != assessment.assessment_scores.length - 1){
                if(Number(assessment_score.total_score) >= Number(assessment.assessment_scores[j - 1].total_score)){
                  state.modalErrors.push(`${i + 1}件目の${j + 1}行目の閾値が高い順に入力されていません。`);
                }
              }
            }
          }
        });
      });

      if(state.modalErrors.length > 0){
        return;
      }
      
      if (!window.confirm('判定を変更します。よろしいですか？')) {
        return;
      }

      const params = {
        assessments: state.assessments
      };

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/practice_sumup_result_rank_list_curriculum/update_assessment/${state.sumup_unit_id}`, params).then(response => {
        alert("処理が完了しました。");
        
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");

    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      //context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sumup_unit_id = context.root.$route.params.sumup_unit_id;
      await http.get(`/api/teacher/practice_sumup_result_rank_list_curriculum?sumup_unit_id=${state.sumup_unit_id}`).then(response => {
        state.sumupGroup = new SumupGroup(response.data.sumup_group);
        state.sumup_unit_name = response.data.sumup_unit.name;
        state.sheet_group_key = response.data.sheet_group_key;
        state.sumupUnitExaminees = response.data.sumup_unit_examinees.map((x: any) => new SumupUnitExaminee(x));
        state.baseAssessments = response.data.base_assessments.map((x: any) => new BaseAssessment(x));
        state.assessments = response.data.assessments.map((x: any) => new Assessment(state.baseAssessments, x, response.data.assessment_scores));
        state.sumupUnitAll = new SumupUnitAll(response.data.sumup_unit_all);
        state.additionTarget = state.sumupUnitExaminees[0];
        state.modalTarget = state.sumupUnitExaminees[0];

        const assessment_examinees: AssessmentExaminee[] = response.data.assessment_examinees.map((x: any) => new AssessmentExaminee(x));

        state.fields = [];
        state.fields.push({key: "student_no_character", label: "受験番号", sortable: true, class: 'text-center b-table-th-td'});
        state.fields.push({key: "student_name", label: "氏名", sortable: true, class: 'text-center b-table-th-td'});
        if(state.sumupUnitAll.man_examinee_count > 0 && state.sumupUnitAll.woman_examinee_count > 0){
          state.fields.push({key: "gender", label: "性別", sortable: true, class: 'text-center b-table-th-td'});
        }
        state.fields.push({key: "addition", label: "備考", sortable: true, class: 'text-center b-table-th-td'});
        if(state.sheet_group_key){
          state.fields.push({key: "result_image", label: "答案", sortable: false, class: 'text-center b-table-th-td'});
          state.fields.push({key: "download", label: "DL", sortable: false, class: 'text-center b-table-th-td'});
        }
        state.fields.push({key: "score", label: "得点", sortable: true, class: 'text-center b-table-th-td', formatter: 'scoreFormatter'});
        state.fields.push({key: "total_rank", label: "順位", sortable: true, class: 'text-center b-table-th-td', formatter: 'rankFormatter'});
        state.fields.push({key: "total_std_score", label: "偏差値", sortable: true, class: 'text-center b-table-th-td'});
          
        if(state.sumupUnitAll.man_examinee_count > 0 && state.sumupUnitAll.woman_examinee_count > 0){
          state.fields.push({key: "gender_rank", label: "順位", sortable: true, class: 'text-center b-table-th-td', formatter: 'rankFormatter'});
          state.fields.push({key: "gender_std_score", label: "偏差値", sortable: true, class: 'text-center b-table-th-td'});
        }

        state.assessmentColspan = state.assessments.length;
        state.isDispAssessment = state.assessments.length > 0;

        state.assessments.forEach(assessment => {
          const key = `assessment_${assessment.id}`;
          state.fields.push({key: key, label: assessment.name, sortable: true, class: 'text-center b-table-th-td'});
          state.sumupUnitExaminees.forEach(sumupUnitExaminee => {
            const assessment_examinee = assessment_examinees.filter(x => x.practice_examinee_id == sumupUnitExaminee.practice_examinee_id && x.assessment_id == assessment.id);
            let value = "-";
            if(assessment_examinee.length > 0){
              const assessment_score = assessment.assessment_scores.filter(x => x.id == assessment_examinee[0].assessment_score_id);
              if(assessment_score.length > 0){
                const base_assessment = state.baseAssessments.filter(x => x.id == assessment_score[0].base_assessment_id);
                if(base_assessment.length > 0){
                  value = base_assessment[0].name;
                }
              }
            }
            // @ts-ignore
            sumupUnitExaminee[key] = value;
          });
        });

        state.examineeColspan = 4;
        if(response.data.is_exists_gender_result){
          state.examineeColspan += 1;
          state.isDispGender = true;
        }
        if(state.sheet_group_key){
          state.examineeColspan += 2;
        }

        if(state.assessments.length == 0){
          state.assessments.push(createEmptyAssessment());
        }

        search();
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        window.history.back();
      });

      adjustHeight();
      window.addEventListener("resize", adjustHeight);
      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
    });

    return {
      ...toRefs(state),
      additionModalRef,
      assessmentModalRef,
      imageModalRef,
      carouselRef,
      pdfDownlaodModalRef,
      convertExecDate,
      scoreFormatter,
      rankFormatter,
      showAdditionModal,
      downloadPdf,
      showAssessmentModal,
      addAssessment,
      deleteAssessment,
      updateAssessment,
      search,
      clearCondition,
      previewImage,
      carouselPrev,
      carouselNext,
      adjustHeight,
      changePrevResultImageModal,
      changeNextResultImageModal,
      createEmptyAssessment,
    };
  }
});
